import React, { useState, useEffect } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import { getCurrencyNameAndIcon } from "../Common/getCurrencynameAndIcon";
import BarChart from "./BarChart";
import Loading from "../Common/Loading";

import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import { Typography } from "@material-ui/core";

const useStyles = makeStyles(() => ({
  image: {
    height: 50,
    objectFit: "contain",
    marginRight: 20,
  },
}));

export default function Currency({}) {
  const [coinInfo, setCoinInfo] = useState(null);
  const [oldData, setOldData] = useState([
    10, 15, 12, 19, 21, 17, 19, 19, 13, 24,
  ]);
  const [predictedData, setPredictedData] = useState([24, 25]);
  const [data, setData] = useState(null);
  const [chartdata, setChartData] = useState([]);
  const [chartLabel, setChartLabel] = useState([]);
  const { cname } = useParams();
  const classes = useStyles();

  useEffect(() => {
    setCoinInfo(getCurrencyNameAndIcon(cname));

    axios
      .get(`https://crypto-prediction-nac.herokuapp.com/currency/${cname}`)
      .then((res) => {
        //console.log("got indivisual currency: ", res.data.data);
        setData(res.data.data[0]);
      })
      .catch((err) => console.log("got error: ", err.message));

    axios
      .post(
        `https://crypto-prediction-nac.herokuapp.com/chart`,
        { cname },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .then((res) => {
        console.log("chart data: ", res.data.data);
        let cdata = [];
        let label = [];
        for (let i = 0; i < res.data.data.length; i++) {
          console.log("inside");
          cdata.push(res.data.data[i].price);
          label.push(res.data.data[i].date);
        }
        //console.log("cdata: ", cdata);
        //console.log("labels: ", label);
        setChartData(cdata);
        setChartLabel(label);
      });

    //setOldData(getArray(data.olddata));
    //setPredictedData(getArray(data.predicteddata));
  }, []);

  if (!data) return <Loading />;

  return (
    <Grid container>
      <Grid item sm={2} xs={false}></Grid>
      <Grid item sm={8} xs={12}>
        <div className={"header-space"}></div>
        <Grid container direction="column">
          <Grid
            container
            alignItems="center"
            style={{
              padding: 10,
            }}
          >
            {coinInfo && (
              <img className={classes.image} src={coinInfo.icon} alt="" />
            )}
            {coinInfo && (
              <Typography variant="h3" color="secondary">
                {coinInfo.name}
              </Typography>
            )}
          </Grid>
          <Grid container>
            <Grid item sm={6} xs={12} style={{ padding: 10 }}>
              <Typography variant="caption" color="textSecondary">
                Currenct Price
              </Typography>
              <Typography variant="h5" color="secondary">
                {data.price}
              </Typography>
              <Typography variant="subtitle1" color="textSecondary">
                min price(last 24hrs):{" "}
                <span className={"light1"}>{data.highest}</span>
              </Typography>
              <Typography variant="subtitle1" color="textSecondary">
                max price(last 24hrs):{" "}
                <span className={"light1"}>{data.lowest}</span>
              </Typography>
              <Typography variant="subtitle1" color="textSecondary">
                market capital:{" "}
                <span className={"light1"}>{data.market_cap}</span>
              </Typography>
              <Typography variant="subtitle1" color="textSecondary">
                volume: <span className={"light1"}>{data.trade_vol}</span>
              </Typography>
              <Typography variant="subtitle1" color="textSecondary">
                last updated: {data.date + " at " + data.time}
              </Typography>
              {coinInfo && (
                <Typography variant="subtitle1" color="textSecondary">
                  official website:{" "}
                  <a
                    href={coinInfo.website}
                    target="_blank"
                    style={{ textDecoration: "none", color: "gray" }}
                  >
                    {coinInfo.website}
                  </a>
                </Typography>
              )}
            </Grid>
            <Grid item sm={6} xs={12} style={{ padding: 10 }}>
              {chartdata.length > 0 ? (
                <BarChart chartdata={chartdata} chartLabel={chartLabel} />
              ) : (
                "Loading..."
              )}
            </Grid>
          </Grid>
        </Grid>
        <div className={"footer-space"}></div>
      </Grid>
      <Grid item sm={2} xs={false}></Grid>
    </Grid>
  );
}
